<script>
import { BNavbarBrand } from "bootstrap-vue";

export default {
  extends: BNavbarBrand
};
</script>